import Raven from "raven-js";
import { pick, F } from "ramda";
import { push } from "react-router-redux";
import { combineEpics } from "redux-observable";
import { candidate, insider, auth } from "routes/paths";
import * as types from "./types";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import * as intercom from "core/integrations/intercom";
import * as linkedinPixel from "core/integrations/linkedin-pixel";
import * as api from "./api";
import * as actions from "./actions";

export default combineEpics(
  action$ =>
    action$
      .ofType(api.linkedInSignIn.types.success, api.signIn.types.success)
      .map(({ payload }) =>
        actions.authenticationRedirect(payload.body, payload.request.backUrl)
      ),
  action$ =>
    action$
      .ofType(types.SIGN_OUT)
      .map(({ payload }) =>
        actions.unauthenticationRedirect(payload.body, payload.backUrl)
      ),
  action$ =>
    action$.ofType(types.UNAUTHENTICATION_REDIRECT).map(({ payload }) => {
      if (payload.backUrl) {
        return push(auth.login + "?redirect=" + payload.backUrl);
      }
      return push(auth.login);
    }),
  action$ =>
    action$.ofType(types.AUTHENTICATION_REDIRECT).map(({ payload }) => {
      if (payload.backUrl) {
        return push(payload.backUrl);
      }
      if (payload.data) {
        switch (payload.data.user_type) {
          case "candidate":
            return push(candidate.main);
          case "insider":
            return push(insider.insiderMain);
          default:
            return push(candidate.main);
        }
      }
      return push(candidate.main);
    }),
  action$ =>
    action$
      .ofType(api.signIn.types.success)
      .do(({ payload }) => {
        mixpanel.identify(payload.body.id, {
          $first_name: payload.body.first_name,
          $last_name: payload.body.last_name,
          $email: payload.body.email
        });
        mixpanel.trackEvent("Login", {
          provider: "Email"
        });
        fbPixel.fbq("trackCustom", "Login");
        dataLayer.push({
          event: "login"
        });
        linkedinPixel.track(292505);
        intercom.setUser(payload.body.id, payload.body.email);
      })
      .filter(() => false),
  action$ =>
    action$
      .ofType(api.linkedInSignIn.types.success)
      .do(({ payload }) => {
        mixpanel.identify(payload.body.id, {
          $first_name: payload.body.first_name,
          $last_name: payload.body.last_name,
          $email: payload.body.email
        });
        if (payload.body.is_new) {
          mixpanel.trackEvent("Signup", {
            provider: "Linkedin"
          });
          dataLayer.push({
            event: "registrationComplete"
          });
          fbPixel.fbq("trackCustom", "registrationComplete");
        }
        mixpanel.trackEvent("Login", {
          provider: "Linkedin"
        });
        fbPixel.fbq("trackCustom", "LoginLinkedin");
        dataLayer.push({
          event: "loginLinkedin"
        });
        linkedinPixel.track(292513);
      })
      .filter(() => false),
  action$ =>
    action$
      .ofType(api.signUp.types.success)
      .do(({ payload }) => {
        mixpanel.setUser(payload.body.id, {
          $first_name: payload.body.first_name,
          $last_name: payload.body.last_name,
          $email: payload.body.email,
          Purchases: 0
        });
        mixpanel.trackEvent("Signup", {
          provider: "Email"
        });
        fbPixel.fbq("init", "486848411701634", {
          email: payload.body.email,
          first_name: payload.body.first_name
        });
        fbPixel.fbq("track", "CompleteRegistration");
        dataLayer.push({
          event: "registrationComplete"
        });
        intercom.setUser(
          payload.body.id,
          payload.body.email,
          payload.body.first_name + " " + payload.body.last_name
        );
        linkedinPixel.track(291577);
      })
      .map(({ payload }) => {
        return api.signIn.request({
          body: pick(["email", "password"], payload.request.body),
          backUrl: `/${window.location.search}`
        });
      }),
  action$ =>
    action$.ofType(api.insiderSignUp.types.success).map(({ payload }) => {
      return api.signIn.request({
        body: pick(["email", "password"], payload.request.body)
      });
    }),
  action$ =>
    action$
      .ofType(api.resetPassword.types.success)
      .mapTo(push(auth.resetPassSuccess)),
  action$ =>
    action$
      .ofType(api.setPassword.types.success)
      .mapTo(push(auth.setPassSuccess)),
  action$ =>
    action$
      .ofType(api.fetchUserData.types.success)
      .do(({ payload }) => {
        if (process.env.NODE_ENV === "production") {
          /**
           * Instantiating Intercom when user data was fetched
           */
          intercom.init();

          /**
           * Passing user data to the Sentry in order to be able identify the user
           */
          Raven.captureBreadcrumb({
            type: "user",
            data: {
              id: payload.body.id,
              type: payload.body.user_type
            }
          });
        }
      })
      .filter(F),
  action$ =>
    action$.ofType(api.fetchUserData.types.failure).map(({ payload }) => {
      return actions.signOut(payload.request.backUrl);
    })
);



// WEBPACK FOOTER //
// ./src/modules/user/auth/epic.js